import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BankAccountTypeDisplay, ISelectOption } from '@lsq-frontend/common-ui';
import { RedactedBankAccount } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ModalService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { formatBankAccountForDisplay } from '../bank-account-helpers/bank-account-format';

@Component({
    selector: 'remove-bank-account-modal-body',
    styleUrls: ['./remove-bank-account-modal.component.scss'],
    template: `
        <div class="remove-bank-account-modal">
            <div *ngIf="isSwitchingAccount" class="bank-account-box-label" i18n>
                The default payment method outlined below will be removed:
            </div>

            <div class="bank-account-box">
                <div class="bank-account-label" i18n>
                    Payment Method
                </div>
                {{ bankAccountLabel }}
            </div>

            <div *ngIf="isSwitchingAccount" class="bank-account-select">
                <div i18n>
                    To prevent a lapse in payment, please choose another payment method to become
                    the new default:
                </div>
                <lsq-select
                    [label]="bankAccountDropdownLabel"
                    [name]="'confirm-banking-info-select'"
                    [formControl]="bankAccountFormControl"
                    [options]="bankAccountSelectOptions"
                    [innerLabel]="true"
                    [isNullable]="false"
                    [arrow]="true"
                >
                </lsq-select>
            </div>

            <div
                *ngIf="bankAccount.isDefault && bankAccountSelectOptions.length === 0"
                class="cannot-remove"
            >
                <div class="cannot-remove-header">
                    You cannot remove your only verified payment method.
                </div>
                <div class="cannot-remove-body">
                    Please contact support at
                    <a href="mailto:FastTrack-Support@LSQ.com">FastTrack-Support@LSQ.com</a> to
                    request removal or alternatively create a new verified payment method.
                </div>
            </div>
        </div>
    `
})
export class RemoveBankAccountModalBodyComponent {
    public bankAccount: RedactedBankAccount;
    public bankAccountFormControl: FormControl;
    public bankAccountSelectOptions: ISelectOption[];
    public bankAccountLabel: string;

    public isSwitchingAccount: boolean;

    public bankAccountDropdownLabel = this._i18n({
        value: 'Select Payment Method',
        meaning: 'Label for bank account selection dropdown'
    });

    constructor(
        private _i18n: I18n,
        private _modalService: ModalService,
        public bankAccountTypeDisplay: BankAccountTypeDisplay
    ) {
        this.bankAccount = this._modalService.modal.data.bankAccount;
        this.bankAccountFormControl = this._modalService.modal.data.bankAccountFormControl;
        this.bankAccountSelectOptions = this._modalService.modal.data.bankAccountSelectOptions;
        this.bankAccountLabel = formatBankAccountForDisplay(
            this.bankAccount,
            this.bankAccountTypeDisplay
        );

        this.isSwitchingAccount =
            this.bankAccount.isDefault && this.bankAccountSelectOptions.length > 0;
    }
}
